/* eslint-disable no-param-reassign,no-unused-vars */
/* global COMMITHASH */
import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import auth from '../auth'

const appSettings = window.app_settings;

let sentryInited = false

function setUserContextFromAuth() {
  try {
    const kcProfile = auth.user || {}
    const tokenParsed = (auth.client && auth.client.tokenParsed) || {}
    const appUser = auth.myPuustelliUser || {}
    const roles = (auth.client && auth.client.realmAccess && auth.client.realmAccess.roles) || []

    Sentry.setUser({
      id: kcProfile.id || tokenParsed.sub || appUser.id || null,
      username: tokenParsed.preferred_username || kcProfile.username,
      email: kcProfile.email || appUser.email,
      name: (kcProfile.firstName && kcProfile.lastName)
        ? `${kcProfile.firstName} ${kcProfile.lastName}`
        : [appUser.firstname, appUser.lastname].filter(Boolean).join(' '),
      country: appUser.country,
      language: appUser.language,
      mypuustelliId: appUser.id,
    })

    Sentry.setContext('auth', {
      keycloak: {
        id: kcProfile.id,
        username: kcProfile.username,
        email: kcProfile.email,
        firstName: kcProfile.firstName,
        lastName: kcProfile.lastName,
        preferred_username: tokenParsed.preferred_username,
        realm: auth.client && auth.client.realm,
        roles,
      },
      mypuustelliUser: appUser,
    })
  } catch (e) {
    try { console.warn('Sentry user context set failed', e) } catch (_) {}
  }
}

function initSentry(vueCtor, router) {
  if (sentryInited) return

  if (!appSettings || !appSettings.APP_ENV || !appSettings.SENTRY_DSN) return

  const dsn = appSettings.SENTRY_DSN
  const environment = appSettings.APP_ENV

  if (dsn === "%SENTRY_DSN%") {
    return;
  }

  Sentry.init({
    Vue: vueCtor,
    dsn,
    environment,
    release: typeof COMMITHASH !== 'undefined' ? COMMITHASH : undefined,
    attachStacktrace: true,
    normalizeDepth: 6,
    sendDefaultPii: true,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: 0.1,
    integrations: [
      Sentry.browserTracingIntegration({
        tracePropagationTargets: [
          /^\/api\//,
          window.location.origin
        ],
      }),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    beforeSend(event, hint) {
      if (event.request) {
        if (event.request.headers) {
          delete event.request.headers['cookie'];
          delete event.request.headers['authorization']
          delete event.request.headers['x-jwt-idtoken']
        }
      }
      return event
    },
  })

  // Populate Sentry user and auth context now that plugin is initialized
  setUserContextFromAuth()

  sentryInited = true
}

const SentryPlugin = {
  install(vue, { router } = {}) {
    // capture Vue global handler as fallback too
    if (Vue.config && typeof Vue.config.errorHandler === 'function') {
      const old = Vue.config.errorHandler
      Vue.config.errorHandler = (err, vm, info) => {
        try { Sentry.captureException(err, { extra: { info } }) } catch (_) {}
        return old(err, vm, info)
      }
    } else {
      Vue.config.errorHandler = (err, vm, info) => {
        try { Sentry.captureException(err, { extra: { info } }) } catch (_) {}
      }
    }

    // Expose $sentry for components
    Vue.mixin({
      computed: {
        $sentry() {
          return Sentry
        }
      }
    })

    // Initialize once Vue constructor and router are known
    initSentry(Vue, router)
  },
  init: initSentry,
  setUserContextFromAuth,
}

export default SentryPlugin
